module.exports = __webpack_public_path__ + "img/find-person-girl.75dec7ef.png";